module.exports = __webpack_public_path__ + "static/media/img_3.b79cfe3e.png";